// src/hooks/useMentalCorrelations.ts
// React hook for mental/cognitive correlations

import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { 
  getMentalCorrelations, 
  MentalCorrelationsResult
} from '@/utils/mentalCorrelations';

export function useMentalCorrelations(days: number = 30): {
  data: MentalCorrelationsResult | null;
  isLoading: boolean;
  error: Error | null;
} {
  const [data, setData] = useState<MentalCorrelationsResult | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchCorrelations = async () => {
      setIsLoading(true);
      setError(null);
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setError(new Error('Please sign in to view mental correlations'));
        setIsLoading(false);
        return;
      }

      try {
        const results = await getMentalCorrelations(user.id, days);
        setData(results);
      } catch (err) {
        console.error('Error fetching mental correlations:', err);
        setError(err instanceof Error ? err : new Error('Failed to load mental correlations'));
      }
      
      setIsLoading(false);
    };

    fetchCorrelations();
  }, [days]);

  return { data, isLoading, error };
}
